import Common from '../common.js';

export default {
    municipalities: function (pageName, name, async, start, page, count, sortField, sortDir, successCallback, errorCallback) {
        var queryParams = '?';
        if (name != null) {
            queryParams += 'name=' + name + '&';
        }
        if (pageName != null) {
            queryParams += 'pageName=' + pageName + '&';
        }
        if (start != null) {
            queryParams += 'start=' + start + '&';
        }
        if (page != null) {
            queryParams += 'page=' + page + '&';
        }
        if (count != null) {
            queryParams += 'count=' + count + '&';
        }
        if (sortField != null) {
            queryParams += 'sortField=' + sortField + '&';
        }
        if (sortDir != null) {
            queryParams += 'sortDir=' + sortDir + '&';
        }

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/document/municipality' + queryParams,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json',
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },
    getMunicipality: function (id) {
        var queryParams = '/' + id + '?';
        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/document/municipality' + queryParams,
            type: 'GET',
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                d = data;
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
            }
        });

        return d;
    },
    saveMunicipality: function (model, successCallback) {
        var result = null;

        $.ajax({
            url: Application.getBasePath() + '/api/document/municipality/save',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                result = data.id;
                Common.showToast('success', 'Успех', 'Изменения успешно сохранены');
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');

                var obj = jQuery.parseJSON(jqXHR.responseText);
                Common.showToast('error', 'Ошибка', obj.message);
            }
        });
        return result;
    },

    deleteMunicipality: function (id) {
        bootbox.confirm("Вы действительно хотите удалить данный элемент?", function (result) {
            if (result) {
                $.ajax({
                    url: Application.getBasePath() + '/api/document/municipality/' + id + '/delete',
                    type: 'POST',
                    dataType: "json",
                    async: false,
                    contentType: 'application/json',
                    success: function (data, textStatus) {
                        result = true;

                        $("#datatable_ajax").dataTable().api().ajax.reload();
                        Common.showToast('success', 'Успех', 'Элемент успешно удалён');
                    },
                    error: function (jqXHR, data, textStatus) {
                        result = false;
                        console.log('catched!');

                        var obj = jQuery.parseJSON(jqXHR.responseText);
                        Common.showToast('error', 'Ошибка', obj.message);
                    }
                });
            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/api/docMunicipality.js